import { render, staticRenderFns } from "./investment.component.vue?vue&type=template&id=20fb31ae&"
import script from "./investment.component.vue?vue&type=script&lang=ts&"
export * from "./investment.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports